module.exports = __webpack_public_path__ + "img/guide_04.1f25a2ff.png";